module.exports = __webpack_public_path__ + "img/searchicon.9da30160.svg";